// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CalendarEvents__calendar___sgR9E {
    margin: 0px 10px;
}

.CalendarEvents__eventNotToday___OAiHj {
    color: gray;
}

.CalendarEvents__currentEvent___TPqXI {
    font-size: 15px;
    color: greenyellow;
    font-weight: bold;
    border: 1px dotted rgb(149 255 162 / 74%);
}

.CalendarEvents__startingInText___DhWaO {
    font-size: 10px;
    position: relative;
    bottom: 1px;
    font-style: italic;
    margin: 0px 4px 0px 0px !important;
}

.CalendarEvents__fromToTimeText___wicCU {
    font-size: 10px;
    margin: 0px 4px 0px 0px !important;
    display: block;
}

.CalendarEvents__nowIcon___Qoy1U {
    font-size: 13px;
    opacity: 0.2;
}

.CalendarEvents__reminder___nYOBL {
    color: coral;
}

.CalendarEvents__free___Th3EX {
    color: gold;
}

.CalendarEvents__event___erAYB {
    margin: 12px 0px;
    background: rgb(0 0 0 / 11%);
    padding: 7px;
    border-radius: 5px;
    display: grid;
    grid-template-columns: 50px 1fr;
    position: relative;
}

.CalendarEvents__completedEvent___RJOs9 {
    background: rgba(46, 184, 11, 0.2);
    opacity: 0.5;
}

.CalendarEvents__allDayEvent___x42by {
    border: 1px dotted rgba(149, 206, 255, 0.74);
}

.CalendarEvents__isInThePast___dKTDs {
    opacity: 0.5;
}

.CalendarEvents__needsToBeBlocked___sX5EO {
    color: #ff8f00;
    font-weight: bold;
}

.CalendarEvents__isBeingChanged___M8O7g {
    border: 2px solid cyan;
}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"calendar": `CalendarEvents__calendar___sgR9E`,
	"eventNotToday": `CalendarEvents__eventNotToday___OAiHj`,
	"currentEvent": `CalendarEvents__currentEvent___TPqXI`,
	"startingInText": `CalendarEvents__startingInText___DhWaO`,
	"fromToTimeText": `CalendarEvents__fromToTimeText___wicCU`,
	"nowIcon": `CalendarEvents__nowIcon___Qoy1U`,
	"reminder": `CalendarEvents__reminder___nYOBL`,
	"free": `CalendarEvents__free___Th3EX`,
	"event": `CalendarEvents__event___erAYB`,
	"completedEvent": `CalendarEvents__completedEvent___RJOs9`,
	"allDayEvent": `CalendarEvents__allDayEvent___x42by`,
	"isInThePast": `CalendarEvents__isInThePast___dKTDs`,
	"needsToBeBlocked": `CalendarEvents__needsToBeBlocked___sX5EO`,
	"isBeingChanged": `CalendarEvents__isBeingChanged___M8O7g`
};
module.exports = ___CSS_LOADER_EXPORT___;
